import { Component, OnInit } from "@angular/core";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { EmpresasDTO } from "src/app/models/empresas.dto";
import { ListColumn } from "src/app/models/list-columns.model";
import { LayoutsService } from "src/app/services/layouts.service";
import { EmpresasService } from "./empresas.service";
import { Filter } from "src/app/shared/classes/filter";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { EmpresasDrawerForm } from "./drawer-form/drawer-form.component";
import { DrawerService } from "src/app/services/drawer.service";

@Component({
  selector: "app-empresas",
  templateUrl: "./empresas.component.html",
  styles: [],
})
export class EmpresasComponent
  extends CrudComponent<EmpresasDTO>
  implements OnInit
{
  columnId: string = "IdEmpresa";
  public columns: ListColumn[] = [
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Direccion",
      property: "Direccion",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  filtro: string = "";
  inactivos: boolean = false;
  realdata: EmpresasDTO[];
  constructor(
    public service: EmpresasService,
    public layoutService: LayoutsService,
    public alerts: AlertasSwalService,
    public drawer: DrawerService,
  ) {
    super(service, alerts);
  }
  ngOnInit(): void {
    this.layoutService.changeHeader('Empresas')
    this.loadRecords();
    this.filter = new Filter<EmpresasDTO>(this.conditions, this.columns, true);
    this.filter.setColumnActive(this.columnActive);
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  //#region Filter

  public filter: Filter<EmpresasDTO>;
  public conditions: Condition<EmpresasDTO> = {
    Nombre: (o, f) => (o.Nombre ?? "").toLocaleLowerCase().indexOf(f) > -1,
    Direccion: (o, f) =>
      (o.Direccion ?? "").toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

  openUser() {
    const drawerRef = this.drawer.open({
      component: EmpresasDrawerForm,
      data: { mode: "create", value: {} },
      width: "500px",
      title: "Empresas",
      classes: "bg-blueGray-100",
      actions: [
        {
          label: "Cancel",
          action: () => this.drawer.close(),
          buttonClass: "bg-red-600",
        },
        {
          label: "Guardar",
          action: (component: EmpresasDrawerForm) => component.saveOver(),
        },
      ],
    });

    drawerRef.afterClosed$.subscribe((result: any) => {
      this.saveForm(result.data);
    });
  }

  override openEdit(value: any) {
    const drawerRef = this.drawer.open({
      component: EmpresasDrawerForm,
      data: { mode: "update", value: value },
      width: "500px",
      title: "Empresas",
      classes: "bg-blueGray-100",
      actions: [
        {
          label: "Cancel",
          action: () => this.drawer.close(),
          buttonClass: "bg-red-600",
        },
        {
          label: "Actualizar",
          action: (component: EmpresasDrawerForm) => component.saveOver(),
        },
      ],
    });

    drawerRef.afterClosed$.subscribe((result: any) => {
      this.saveForm(result.data);
    });
  }
  public tableActionsCC = [
    {
      label: "Nuevo",
      icon: "plus",
      className:
        "text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blueGray-600 text-white disabled:opacity-50",
      action: () => this.openUser(),
    },
  ];
}
